import { render, staticRenderFns } from "./BaseZonalSectionComponent.vue?vue&type=template&id=5a155eb0"
import script from "./BaseZonalSectionComponent.vue?vue&type=script&lang=js"
export * from "./BaseZonalSectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports